FD = (function ($, me) {
    //  callback prefix
    var CALLBACKPREFIX = {
        NONE: 0,
        DEFAULT: 1,
        PROJECTEDIT: 2,
        PAGEACCESS: 3,
        FEEDBACK: 4,
        MEDIA_MANAGER: 5,
        PROJECTADD: 6,
        LINK8D: 7,
        FAVORITEVIEW: 8,
        APPLICATIONHELP: 9,
        CALCULATOR: 10,
        LOCATIONS: 11,
        TIMETRACKER: 12,
        PURCHASE_ORDER: 13,
        LEARNING_SUBSCRIPTION: 14,
        REPORT: 15
    };
    var APP_HELP_BUTTON = '#APP_HELP_BUTTON';
    var URL_COMMON = '/Common/Common/';
    var modalLock = false;
    var idleTimeout;
    var label;
    var mprogress = new Mprogress({
        parent: '#PROGRESS-TOP'
    });
    var progressCount = 0;
    var timeSpentOnPageLock = false;

    //  set callback by prefix
    function setCallBackByPrefix(prefix) {
        switch (prefix) {
            case CALLBACKPREFIX.DEFAULT:
                return 'PAGE.getAfterControlEvent';
            case CALLBACKPREFIX.PROJECTEDIT:
                return 'PROJECTEDIT.getAfterControlEvent';
            case CALLBACKPREFIX.PROJECTADD:
                return 'PROJECTADD.getAfterControlEvent';
            case CALLBACKPREFIX.PAGEACCESS:
                return 'PAGEACCESS.getAfterControlEvent';
            case CALLBACKPREFIX.FEEDBACK:
                return 'FEEDBACK.getAfterControlEvent';
            case CALLBACKPREFIX.MEDIA_MANAGER:
                return 'MEDIA_MANAGER.getAfterControlEvent';
            case CALLBACKPREFIX.LINK8D:
                return 'LINK8D.getAfterControlEvent';
            case CALLBACKPREFIX.FAVORITEVIEW:
                return 'FAVORITEVIEW.getAfterControlEvent';
            case CALLBACKPREFIX.APPLICATIONHELP:
                return 'APPLICATIONHELP.getAfterControlEvent';
            case CALLBACKPREFIX.LOCATIONS:
                return 'LOCATIONS.getAfterControlEvent';
            case CALLBACKPREFIX.TIMETRACKER:
                return 'TIMETRACKER.getAfterControlEvent';
            case CALLBACKPREFIX.PURCHASE_ORDER:
                return 'PURCHASEORDER.getAfterControlEvent';
            case CALLBACKPREFIX.LEARNING_SUBSCRIPTION:
                return 'LEARNINGSUBSCRIPTION.getAfterControlEvent';
            case CALLBACKPREFIX.REPORT:
                return 'REPORT.getAfterControlEvent';
            default:
                return 'PAGE.getAfterControlEvent';
        }
    }



    /* ========================================================================
     *  init
     * ========================================================================
    */
    function init() {

        //  set the page dimensions [ get the top starting point ]
        setPageDimension();


        //  set left navigation
        me.SITE.setLeftNavControl();


        //  set scroll container
        me.CONTROL.setScroll("#LEFT_NAVIGATION");
        me.CONTROL.setScroll("#POP_USEREXPLORER");
        me.CONTROL.setScroll("#POP_APPLICATION");
        me.CONTROL.setScroll("#SS_FAVORITES_LIST");
        me.CONTROL.setScroll("#SS_HISTORY_LIST");
        me.CONTROL.setScroll("#POP_SEARCH");

        // Set favorite view related buttons
        me.CONTROL.setButton(true, "#SS_FAVORITES_LIST");
        me.CONTROL.setButton(true, "#SITE_APP_LIST");

        // enable top controls
        me.SITE.setTopControlElement();

        //  set top popovers
        me.SITE.setTopPopovers();

        //  set horizonalscroll
        setHorizontalScroll();

        //  set site search control
        me.SITE.setSiteSearchControl();

        //  default site view [ comfort, cozy ...]
        me.SITE.setDefaultSiteView();

        //  set disable empty A tags
        me.setDisableEmptyATag();

        //  set site tool collapse
        me.setSiteToolCollapse();

        //  set top scroll
        me.setUIToTop();

        //  set toggle full screen
        me.setToggleFullScreen();

        // Enable data-popover attribute.
        me.setPopover();

        // Enable all controls (must happen after global setup)
        $('body').enableControls();

        // reset body content top margin on screen resize
        $(window).on('resize', function () {
            me.resetBodyContentMarginTop();
        });

        // by default, disable highcharts export context menu
        Highcharts.setOptions({
            lang: {
                thousandsSep: ','
            },
            exporting: {
                enabled: false
            },
            chart: {
                plotShadow: false,
                animation: false
            },
            plotOptions: {
                series: {
                    animation: false
                }
            }
        });

        $(APP_HELP_BUTTON).off().on('click', function () {
            me.APPLICATIONHELP.getApplicationHelpModal($(this).data('applicationid'), $(this).data('viewid'));
        });

        resetTimer();
        document.onmousemove = resetTimer;
        document.onkeypress = resetTimer;
        me.setToolTip();

        // Send client timezone to server
        sendClientTimeZone();

        // Stop click's on disabled links.
        $(document).on("click", "a[href][href!='#'][href!='']", function (e) {
            if ($(e.currentTarget).attr('disabled') || $(e.currentTarget).data('noedit')) {
                return false;
            }
        });

        // Enable select-all on controls.
        $(document).on("click", "textarea.select-all", function () {
            $(this).select();
        })

        startTracking();

        $("[data-ajax=true]").click(function () {
            if ($(this).attr('disabled')) {
                return false;
            }
        });

        if (me.getUserProps().clickSelectsAllText) {
            $(document).on('focus', "input,textarea", function () {
                $(this).select();
            })
        }

        setUndoHandler();
    }


    /* ========================================================================
     *  private methods
     * ========================================================================
    */
    var undoInterval;
    function setUndoHandler() {
        $.hotkeys.options.filterInputAcceptingElements = false;

        $(document).on('keydown', null, 'ctrl+z', setUndo);
        $(document).on('keydown', null, 'crtl+shift+z', setUndo);

        function setUndo() {
            document.isUndo = true;
            if (undoInterval) {
                clearTimeout(undoInterval);
            }
            // Being extra safe so a dangling isUndo doesn't cause problems.
            undoInterval = setTimeout(clearUndo, 100);
        }
        function clearUndo() {
            if (undoInterval) {
                clearTimeout(undoInterval);
            }
            document.isUndo = false;
        }
    }

    //  get unique id
    function getUID(prefix) {
        do prefix += ~~(Math.random() * 1000000);
        while (document.getElementById(prefix));
        return prefix;
    }


    //  get element position
    function getPosition(element) {
        element = element || this.$element;

        var el = element[0];
        var isBody = el.tagName === 'BODY';

        var elRect = el.getBoundingClientRect();

        if (elRect.width === null) {
            // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
            elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top });
        }
        var elOffset = isBody ? { top: 0, left: 0 } : element.offset();
        var scroll = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : element.scrollTop() };
        var windowscroll = { windowscroll: $(window).scrollLeft() };
        var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null;

        return $.extend({}, elRect, scroll, outerDims, elOffset, windowscroll);
    }


    //  get window height
    function getWindowHeight(adj) {
        var val = adj === undefined ? 0 : adj;
        return $(window).height() + val;
    }


    //  get window width
    function getWindowWidth(adj) {
        var val = adj === undefined ? 0 : adj;
        return $(window).width() + val;
    }


    //  set comma
    function setComma(value) {
        if (!value || value === 0) {
            return value;
        } else {
            var parts = value.toString().split(".");
            return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] ? "." + parts[1] : "");
        }
        //return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }


    //  set control item options
    function setControlItemOptions(elem, options) {
        options.element = elem;
        var PARENT = '[data-parent="true"]';
        var targetElm = options.useparent ? elem.closest(PARENT) : elem;
        var targetData = {};
        if (targetElm.length) {
            targetData = targetElm.data();
        }

        // update data
        options.callback = setCallBackByPrefix(targetData.callbackprefix);
        options.parentid = targetData.parentid || 0;

        //  set data
        elem.data(options);
    }


    //  set hightlight on listgroup
    function setHighlightListGroup(container, dataID) {
        if (typeof container === 'string') container = $(container);

        container.children('a').each(function () {
            var e = $(this);
            var data = e.data();
            if (data !== 'undefined') {
                if (data.parentid !== 'undefined') {
                    if (data.parentid === dataID) e.addClass('active');
                }
            }
        });

    }


    //  set input focus
    function setInputFocus(e, select) {
        if (typeof e === 'string') e = $(e);
        var val = e.val();
        e.focus().val('').val(val);
        if (select) e.select();
    }


    //  set no comma
    function setNoComma(value) {
        var noComma = new RegExp(',', 'g');
        return value.replace(noComma, '');
    }


    // configure tracking code
    function startTracking() {
        if (timeSpentOnPageLock) {
            return;
        }
        var inactiveCount = 0,
            maxInactiveCount = 10, // Mark user as inactive after 5 minutes
            intervalPeriod = 300000,
            timeTrackingInterval = null,
            visitID = null,
            dateOnly = false;
        timeSpentOnPageLock = true;
        var initialOptions = {
            url: URL_COMMON + 'RecordTimeSpentOnPage',
            params: {
                model: {
                    ViewID: me.getViewID(),
                    PageUrl: document.location.href
                }
            },
            callback: afterData
        };

        me.AJAX.setAJAX(initialOptions);

        function afterData(result) {
            timeSpentOnPageLock = false;
            visitID = result.data.visitID;
            updateNotificationCount(result.data.notificationCount);
        }

        function recordTimeSpentOnPage(callback) {
            if (timeSpentOnPageLock) {
                return;
            }
            timeSpentOnPageLock = true;
            var model = {
                ViewID: me.getViewID(),
                PageUrl: document.location.href,
                VisitID: visitID,
                dateOnly: dateOnly
            };

            var options = {
                url: URL_COMMON + 'RecordTimeSpentOnPage',
                params: {
                    model: model
                },
                callback: afterRecordCallback
            };

            me.AJAX.setAJAX(options);


            function afterRecordCallback(result) {
                timeSpentOnPageLock = false;
                updateNotificationCount(result.data.notificationCount);
                if (callback && typeof (callback) === 'function') {
                    callback(result);
                }
            }
        }

        function setTimeTrackingInterval() {
            return setInterval(function () {
                if (++inactiveCount === maxInactiveCount) {
                    clearInterval(timeTrackingInterval);
                    timeTrackingInterval = null;
                    return;
                }

                recordTimeSpentOnPage();
            }, intervalPeriod);
        }

        // log the time we left, save a bit so that next time we record data we only record the enddate
        function handleTimeoutBlur() {
            inactiveCount = 0;
            clearInterval(timeTrackingInterval);
            timeTrackingInterval = null;
            recordTimeSpentOnPage(setDateOnly);
        }

        function setDateOnly() {
            dateOnly = true;
        }

        function resetDateOnly() {
            dateOnly = false;
            timeTrackingInterval = setTimeTrackingInterval();
        }

        $(window).on('mousedown click scroll keypress focus touchstart', function () {
            inactiveCount = 0;
            if (!timeTrackingInterval) {
                if (dateOnly) {
                    timeTrackingInterval = -1; // Temporary value to prevent duplicate calls given the attached events can easily fire multiple times
                    recordTimeSpentOnPage(resetDateOnly);
                } else {
                    timeTrackingInterval = setTimeTrackingInterval();
                }
            }
        }).on('blur', function () {
            handleTimeoutBlur();
        });

        function updateNotificationCount(total) {
            $('#SITE_NOTIFICATION_COUNT').text(total);
            $('#SITE_NOTIFICATION_BUTTON').toggleClass('hidden', total == 0).parent().toggleClass('hover', total != 0);
        }
    }


    //  set page dimensions
    function setPageDimension() {
        var siteTopNavigation = $('[data-sitetopnav="true"]');
        var fixedTopContent = $('[data-sitefixedtop="true"]');
        var pageContent = $('[data-sitepagecontent="true"]');
        var tables = $("table[data-headerfixset='true']");

        var topNavHeight = Math.abs(siteTopNavigation.height());
        var fixedTopHeight = Math.abs(fixedTopContent.height());
        var pageTopHeight = fixedTopHeight + topNavHeight;

        siteTopNavigation.css({ marginTop: 0 });
        fixedTopContent.css({ top: topNavHeight });
        pageContent.css({ marginTop: pageTopHeight - 1 });

        if (tables && tables.length > 0) {
            tables.floatThead('destroy');
            tables.each(function (index, element) {
                $(element).attr('data-headerfixset', false);
                me.CONTROL.setTableInPage($(element));
            });
        }
    }


    //  set horizontal scroll
    function setHorizontalScroll() {
        var ELEM = '[data-horizontalscroll="true"]';        //  inner div
        var scrollDiv = $(ELEM);

        function scrollHorizontal() {
            scrollDiv.css('margin-left', -$(window).scrollLeft());
        }

        $(document).off('scroll.horizontalscroller');
        $(document).on('scroll.horizontalscroller', scrollHorizontal);
    }


    //  pulls the value from all form fields on page
    function getFormFields(container) {
        var fldList;
        if (container) {
            fldList = $(container).find('[data-fldname]');
        } else {
            fldList = $('[data-fldname]');
        }

        var ctrlAR = {};

        if (fldList.length === 0) return {};

        fldList.each(function () {
            var elem = $(this);
            var fldName = elem.data('fldname');
            let val = null;
            if (elem.data('fd') === 'select') {
                val = elem.val();
            } else if (elem.is(".checkbox-group")) {
                val = elem.data('value') && elem.data('value') !== "" ? elem.data('value') : false;
                val = val ? [elem.closest('[data-parent=true]').data('parentid')] : [];
                // Merge with other control's of the same name.
                if (typeof ctrlAR[fldName] == 'object') {
                    val = val.concat(ctrlAR[fldName]);
                }
            } else if (elem.data('fd') === 'checkbox') {
                val = elem.data('value') && elem.data('value') !== "" ? elem.data('value') : false;
            } else if (elem.is(".list-group")) {
                val = $(".active:not(.hidden)", elem).map(function () {
                    return $(this).data('value') ? $(this).data('value') : $(this).val();
                }).toArray();
                // Merge with other control's of the same name.
                if (typeof ctrlAR[fldName] == 'object') {
                    val = val.concat(ctrlAR[fldName]);
                }
            } else if (elem.is("[type=file]")) {
                val = elem[0].files;
            } else {
                if (elem.data('value')) {
                    val = elem.data('value');
                    if (elem.data('fd') == 'number')
                        var elemValue = Number(elem.val());
                    if (!isNaN(elemValue) && val != elemValue) {
                        val = elemValue;
                    }
                } else {
                    val = elem.val();
                }
            }

            ctrlAR[fldName] = val;
        });

        return ctrlAR;
    }


    function refresh() {
        var options = {
            url: URL_COMMON + 'Ping'
        };

        me.AJAX.setAJAX(options);

        resetTimer();
    }


    //  We refresh the page if sitting idle for 3 hours to prevent session expiration
    function resetTimer() {
        clearTimeout(idleTimeout);
        idleTimeout = setTimeout(refresh, 10800000);
    }


    //  Send client time zone to server
    function sendClientTimeZone() {
        var offset = new Date().getTimezoneOffset();
        var options = {
            url: URL_COMMON + 'SetClientOffset?offset=' + offset
        };

        me.AJAX.setAJAX(options);
    }


    /* ========================================================================
     *  public methods
     * ========================================================================
    */


    //  get function from string
    me.getFuctionFromString = function (root, string) {
        var scope = root;
        var scopeSplit = string.split('.');

        for (var i = 0; i < scopeSplit.length - 1; i++) {
            scope = scope[scopeSplit[i]];

            if (scope === undefined) return;
        }
        return scope[scopeSplit[scopeSplit.length - 1]];
    };


    //  get position
    me.getPosition = function (elem) {
        return getPosition(elem);
    };


    //  get uniqueid
    me.getUID = function (prefix) {
        return getUID(prefix);
    };


    //  get window height
    me.getWindowHeight = function (adj) {
        return getWindowHeight(adj);
    };


    //  get window width
    me.getWindowWidth = function (adj) {
        return getWindowWidth(adj);
    };


    //  set static class on row to prevent background from changing when in popover or other
    me.setRowStaticHighlightFromTarget = function (elem) {
        if (elem === undefined) return;

        var highlightClass = "highlight-child-withborder";
        var tr = elem.parents('tr');
        if (tr.length > 0) {
            var table = tr.parents('table');

            table.find('tr').removeClass('static').removeClass('highlight-child-withborder');
            tr.addClass('static').addClass(highlightClass);
        }
    };


    //  set BR 2 LN
    me.setBR2LN = function (elem) {
        return elem.html().trim().replace(/<\s*\/?br>/ig, "\r\n");
    };


    //  set global callback
    me.setCallBackFromData = function (elem, data) {
        var props = elem.data();

        if (elem.data().callback === undefined) return;
        if (props.callback.length === 0 || props.callback === null) return;

        var func = me.getFuctionFromString(me, props.callback);

        if (typeof func === 'function') func(data);
    };


    //  set callback prefix
    me.setCallBackPrefix = function (prefix) {
        return setCallBackByPrefix(prefix);
    };


    me.setPageAccess = function () {
        $('#PAGEACESS_BUTTON').click(function () {
            me.PAGEACCESS.showModal();
        });
    };


    //  set close button
    me.setCloseButton = function () {
        $(document).on({
            'click': function (e) {
                e.preventDefault();
                $(this).parents('[data-parent="true"]').hide();
            }
        }, '[data-btn="close"]');
    };


    //  set comma
    me.setComma = function (val) {
        return setComma(val);
    };


    //  set control item options
    me.setControlItemOptions = function (elem, options) {
        return setControlItemOptions(elem, options);
    };


    //  set date parse
    me.setDateParse = function (val) {
        return new Date(parseInt(val.substr(6)));
    };


    //  set disable empty A tags
    me.setDisableEmptyATag = function () {
        $(document).on({
            'click': function (e) {
                e.preventDefault();
            }
        }, '[href="#"]');
    };



    //  set feedback
    me.setFeedBack = function () {
        $('[data-feedbackbtn="true"]').click(function () {
            me.FEEDBACK.init();
        });
    };


    me.setPopover = function () {
        $(document).on("click", "[data-popover=true]", function () {
            var options = {
                placement: 'horizontal',
                multi: false,
                cache: false,
                arrow: false,
                dismissible: true,
                closeable: true,
                title: $(this).data('popover-title'),
                style: $(this).data('popover-style'),
                content: function () {
                    return $(this).data('popover-html') ? $(this).data('popover-html') : $($(this).data('popover-target')).html();
                },
                onHide: function (e) {
                    $('body').removeClass('out');
                },
                width: '600',
                onShow: function (modal) {
                    $(modal).addClass("popover-border popover-primary");
                },
                type: 'html'
            };

            if (!$(this).data('plugin_webuiPopover')) {
                $(this).webuiPopover(options);
            }
            $(this).webuiPopover('show');
        });
    }



    me.setImpersonating = function () {
        $('[data-impersonating="true"]').click(function () {
            var options = {
                url: '/SiteAdmin/SwitchUserAccount/HandleAbortImpersonation',
                callback: afterData,
                ishtml: false
            };

            me.AJAX.setAJAX(options);

            function afterData(result) {
                if (result.data) {
                    window.refresh();
                }
            };
        });
    }

    me.setChangeLog = function () {
        $('[data-changelog=true]').click(function () {
            var options = {
                url: '/SiteAdmin/ChangeLog/GetViewChangeLogModal',
                callback: afterData,
                ishtml: true
            };

            me.AJAX.setAJAX(options);

            function afterData(result) {
                if (result.data) {
                    $('body').append(result.data);

                    $('#CHANGELOG_MODAL').off().on('shown.bs.modal', function () {
                        afterHtmlUpdate($(this));
                    }).on('hidden.bs.modal', function () {
                        me.setToolTip();
                        $('#CHANGELOG_MODAL').remove();
                    }).modal('show');
                } else {
                    me.setModalLock(false);
                }
            }
            function afterHtmlUpdate(modal) {
                me.CONTROL.setButton(false, modal);
                $(".btn", modal).click(function () {
                    if ($(this).is("[disabled]")) {
                        return;
                    }

                    var options = {
                        url: '/SiteAdmin/ChangeLog/GetViewChangeLogModal',
                        params: {
                            scheduleId: $(this).data('value')
                        },
                        callback: afterDataPartial,
                        ishtml: true
                    };

                    me.AJAX.setAJAX(options);
                });

                me.setToolTipDestroy();
                me.setModalLock(false);
            }

            function afterDataPartial(result) {
                $('#CHANGELOG_MODAL').html($(result.data).html());
                afterHtmlUpdate($('#CHANGELOG_MODAL'));
            }
        });

        $('#RELEASE_NOTIFICATION [data-changelog-suppress=true]').click(function () {
            me.setCookie('SuppressReleaseNotification', true, 1, true);
            $('#RELEASE_NOTIFICATION').remove();
        });
    }


    //  set highlight list group
    me.setHighlightListGroup = function (elem, id) {
        setHighlightListGroup(elem, id);
    };


    //  set htmldecode
    me.setHtmlDecode = function (val) {
        return $('<div/>').html(val).text();
    };


    //  set htmlencode
    me.setHtmlEncode = function (val) {
        return $('<div/>').text(val).html();
    };


    //  set input focus
    me.setInputFocus = function (elem, highLight) {
        setInputFocus(elem, highLight);
    };


    //  set is object
    me.setIsObject = function (elem) {
        if (elem === null) { return false; }
        return typeof elem === 'function' || typeof elem === 'object';
    };


    ////  set LN 2 BR
    //me.setLN2BR = function (val) {
    //    return val.replace(new RegExp('\r?\n', 'g'), '<br />');
    //};


    //  set no comma
    me.setNoComma = function (val) {
        return setNoComma(val);
    };


    //  set page dimensions
    me.setPageDimension = function () {
        setPageDimension();
    };


    //  set popover options
    me.setPopoverOptions = function (url) {
        return {
            placement: 'vertical',
            multi: false,
            padding: false,
            cache: false,
            arrow: false,
            dismissible: true,
            closeable: false,
            type: 'async',
            trigger: 'click',
            url: url,
            style: 'inverse',
            async: {
                type: 'POST',
                success: function (that, data) { }
            },
            content: function (data) {
                return data;
            },
            onHide: function (e) { },
            onShow: function (e) { }
        };
    };


    //  top progress bar
    me.setTopProgressBar = function () {
        progressCount++;
        mprogress.start();
    };

    me.unsetTopProgressBar = function () {
        if (progressCount > 0) {
            progressCount--;
        }
        if (progressCount === 0) {
            // Ui shouldn't wait for progressBar chagnes
            fastdom.mutate(() => mprogress.end());
        }
    };


    //  confirm dialogue
    me.setConfirmDialogue = function (message, dataTag, cancelDataTag, callbackPrefix, parentid, confirmLabel, cancelLabel) {
        if (me.getModalLock()) {
            return;
        }

        me.setModalLock(true);
        var options = {
            url: URL_COMMON + 'ConfirmDialogue',
            params: {
                message: message,
                dataTag: dataTag,
                cancelDataTag: cancelDataTag,
                callbackPrefix: callbackPrefix,
                confirmLabel,
                cancelLabel
            },
            callback: afterData,
            ishtml: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            var modal = $('<div id="CONFIRMATION_MODAL" class="modal fade"></div>');
            modal.html(result.data).off().on('shown.bs.modal', function () {
                if (typeof (parentid) != "undefined") {
                    $(".modal-dialog", modal).attr("data-parentid", parentid);
                }
                me.setToolTipDestroy();
                me.CONTROL.setButton(true, modal);
                me.setModalLock(false);
            }).on('hidden.bs.modal', function () {
                me.setToolTip();
                modal.remove();
            }).modal({
                backdrop: 'static',
                keyboard: false
            }).modal('show');
        }
    };


    me.hideConfirmDialogue = function (hideCallback) {
        $('#CONFIRMATION_MODAL').off().on('hidden.bs.modal', function () {
            $('#CONFIRMATION_MODAL').remove();
            me.setToolTip();
            if (hideCallback && typeof hideCallback === 'function') {
                hideCallback();
            }
        }).modal('hide');
    };


    //  set site tool collapse
    me.setSiteToolCollapse = function () {
        var ELEM = '[data-sitecontrol="true"]';
        $('[data-sitetogglecontrol="true"]').on('click', function () {
            var e = $(this);
            if (e.hasClass('in')) {
                e.removeClass('in');
                $(ELEM).removeClass('hidden');
                e.children('i').removeClass('fa-caret-square-o-down').addClass('fa-caret-square-o-up');
            } else {
                e.addClass('in');
                $(ELEM).addClass('hidden');
                e.children('i').removeClass('fa-caret-square-o-up').addClass('fa-caret-square-o-down');
            }
            me.setPageDimension();
        });
    };


    //  set scrolltop
    me.setScrollTop = function () {
        $('html, body').animate({ scrollTop: 0 }, 'fast');
    };



    // scroll to element referenced by provided selector
    // If no offset is provided, the height of the fixed top content will be calculated and added to the
    // scroll top offset value
    me.setScrollTo = function (selector, offset) {
        if (!offset) {
            offset = $('.site-fixed-top-content').height() + $('.site-top-navigation').height();
        }

        $('html, body').animate({
            scrollTop: $(selector).offset().top - offset
        }, 1000);
    };


    // scroll to element referenced by provided selector
    me.setScrollToHorizontal = function (selector, offset) {
        offset = offset || 500;
        $('html, body').animate({
            scrollLeft: $(selector).offset().left - offset
        }, 1000);
    };


    //  set tabindex
    me.setTabIndex = function () {
        var list = $('[data-tab="true"]');
        if (list.length === 0) return;
        var tab = 1000;
        list.each(function () {
            $(this).attr('tabindex', tab);
            tab++;
        });
    };


    //  set table order
    me.setTableOrder = function (elem) {
        $(elem).find('tr').each(function (i) {
            var tr = $(this);
            var counter = tr.find('.row-counter');
            counter.html(i + 1);
        });
    };


    //  set table insert by ID
    me.setTableInsertByID = function (elem, newID) {
        var newRow = $('[data-parentid="' + newID + '"]');
        if (!newRow.length) {
            return;
        }
        $('html, body').animate({ scrollTop: newRow.offset().top - 200 }, 2000, function () {
            $('[data-parentid="' + newID + '"]').addClass('highlight-child-withborder'); // can't use newRow inside here
        });
    };


    //  set textarea focus
    me.setTextAreaFocus = function () {
        $(document).off('focus.taf');
        $(document).on('focus.taf', 'textarea', function () {
            var e = $(this);
            var val = e.val();
            e.val('').val(val);
        });
    };


    //  set li insert by ID
    me.setLIInsertByID = function (elem, newID) {
        $(elem).find('li').each(function (i) {
            var li = $(this);
            var id = +li.data('parentid');

            if (id === newID) {
                //li.addClass('highlight-child-withborder');
                $('html,body').animate({ scrollTop: document.body.scrollHeight }, 800, 'linear');
            }
        });
    };


    //  set tooltip
    me.setToolTip = function (container, delay = 300) {
        if (container) {
            if (container instanceof jQuery) {
                $('[data-tt]', container).tooltip({ delay: delay, trigger: 'hover', sanitize: false });
            } else {
                $(' [data-tt]', container).tooltip({ delay: delay, trigger: 'hover', sanitize: false });
            }
        } else {
            $('[data-tt]').tooltip({ delay: delay, trigger: 'hover', sanitize: false });
        }
    };


    //  set tooltip destroy
    me.setToolTipDestroy = function (container) {
        $("[role=tooltip]").each(function () {
            if ($($(this).data()['bs.tooltip'].element).closest(document.documentElement).length == 0) {
                $(this).remove()
            }
        });

        if (container) {
            $('[data-tt][aria-describedby]', container).tooltip('hide');
        } else {
            $('[data-tt="true"][aria-describedby]').tooltip('hide');
        }
    };


    //  set toggle full screen
    me.setToggleFullScreen = function () {
        var elem = $('[data-toggle-fullscreen="true"]');
        // Not supported under IE (requires jQuery Browser)
        if (window.jQBrowser.msie) {
            elem.addClass('hide');
        } else {
            elem.on('click', function (e) {
                e.preventDefault();

                if (screenfull.enabled) {

                    screenfull.toggle();

                } else {
                    // Fullscreen not enabled ;
                }
            });
        }
    };


    me.setHighlightTableChange = function (tableCellList) {
        if (tableCellList && tableCellList.length > 0) {
            for (var x = 0; x < tableCellList.length; x++) {
                $(tableCellList[x]).addClass('highlight-change');
            }
        }
        setTimeout(function () {
            $('.highlight-change').addClass('unhighlight-change');
        }, 1000);
        setTimeout(function () {
            $('.highlight-change').removeClass('highlight-change unhighlight-change');
        }, 2000);
    };


    //  set UItoTop
    me.setUIToTop = function () {
        var defaults = {
            text: '',
            min: 250,
            inDelay: 500,
            outDelay: 400,
            containerID: 'toTop',
            containerHoverID: 'toTopHover',
            scrollSpeed: 700,
            easingType: 'linear'
        };

        var settings = $.extend({}, defaults),
            containerIDhash = '#' + settings.containerID,
            containerHoverIDHash = '#' + settings.containerHoverID,
            kill;

        kill ? 1 : 0;

        if (kill === 1) {
            return;
        } else {
            $('.site-body-content').append('<a href="#" id="' + settings.containerID + '">&nbsp;</a>');
            $(containerIDhash).hide().on('click.UItoTop', function () {
                $('html, body').animate({ scrollTop: 0 }, settings.scrollSpeed, settings.easingType);
                $('#' + settings.containerHoverID, this).animate({ 'opacity': 0 }, settings.inDelay, settings.easingType);
                return false;
            })
                .prepend('<span id="' + settings.containerHoverID + '"><i class="fa fa-chevron-circle-up fa-2x"></i></span>')
                .hover(function () {
                    $(containerHoverIDHash, this).animate({
                        'opacity': 1
                    }, 600, 'linear');
                }, function () {
                    $(containerHoverIDHash, this).animate({
                        'opacity': 1
                    }, 700, 'linear');
                });
            $(window).scroll(function (e) {
                var sd = $(window).scrollTop();
                if (typeof document.body.style.maxHeight === "undefined") {
                    $(containerIDhash).css({
                        'position': 'absolute',
                        'top': sd + $(window).height() - 50
                    });
                }
                if (sd > settings.min) {
                    $(containerIDhash).fadeIn(settings.inDelay);
                }
                else {
                    $(containerIDhash).fadeOut(settings.Outdelay);
                }
            });
        }
    };


    //  set validate form
    me.getFormFields = function (container) {
        return getFormFields(container);
    };


    //  set cookie
    me.setCookie = function (name, value, days, global) {
        var expires = "";
        var date = new Date();
        days = days || 31;
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
        var domain = global && !document.location.host.startsWith('localhost') ? "; domain=.innotecgroup.com" : '';
        document.cookie = name + "=" + value + expires + domain + "; path=/";
    };


    me.resetBodyContentMarginTop = function () {
        var topMargin =
            $('[data-sitepagecontent]').css('margin-top', $('[data-sitefixedtop]').outerHeight(true) + $('[data-sitetopnav]').outerHeight(true));
    };


    // Global variable and public accessor/setter to avoid issue where modal tries to open itself twice
    me.setModalLock = function (isModalLocked) {
        modalLock = isModalLocked || false;
    };


    me.getModalLock = function () {
        return modalLock;
    };

    me.updateQS = function (uri, key, value) {
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf('?') !== -1 ? "&" : "?";
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + "=" + value + '$2');
        }
        else {
            return uri + separator + key + "=" + value;
        }
    };


    me.toQS = function (key, data) {
        if (Array.isArray(data) && data.length) {
            if (typeof data[0] == 'object') {
                return data.map(function (item, idx) {
                    var qsString = '';
                    $.each(item, function (name) {
                        qsString += "&" + key + "[" + idx + "]." + name + "=" + this;
                    });
                    return qsString;
                }).join('')
            } else {
                return data.map(function (item, idx) {
                    return "&" + key + "=" + item;
                }).join('')
            }
        } else if (typeof data == 'object') {
            return $.param(data);
        } else if (typeof data != 'array') {
            return '&' + key + '=' + data;
        } else {
            return '';
        }
    }

    var ELEM = '[data-pin]';
    me.pinElements = function (container) {
        var list = '';
        if (container) {
            if (typeof container === 'string') {
                container = $(container);
            }
            list = container.find(ELEM);
        } else {
            list = $(ELEM);
        }

        $(list).each(function (aa) {
            var self = $(this);
            var pinTo = $(self.data('pin'));
            if (pinTo.length > 0) {
                var offset = self.data('pin-offset') ? self.data('pin-offset') : 0;
                if (self.position().top < pinTo.position().top) {
                    self.css('margin-top', pinTo.position().top - self.position().top + offset);
                }
            }
        });
    }


    //capturedInputContent is a string version of your input parameters, you can achieve this easily using JSON.stringify([your input parameter object])
    me.logError = function (application, actionName, capturedInputContent, exceptionMessage) {
        const err = new Error(application + ':' + actionName,
            {
                cause: exceptionMessage,
                details: capturedInputContent
            });

        window.appInsights.trackException(err);
    };


    me.refreshTableAfterUpdate = function (tableElem, dataCallback) {
        var rowCounters = tableElem.find('.row-counter');
        if (rowCounters.length === 0) {
            dataCallback();
        } else {
            rowCounters.each(function (index) {
                this.innerHTML = index + 1;
            });
        }
    };


    me.setLoadingButton = function (elem) {
        elem = $(elem);
        elem.width(elem.width()).prop('disabled', true).addClass('disabled btn-disabled').html('<i class="fa fa-fw fa-spinner fa-spin"></i>');
    };


    me.unsetLoadingButton = function (elem, text) {
        elem = $(elem);
        elem.prop('disabled', false).removeClass('disabled btn-disabled').html(text);
    };

    me.setSelectOptions = function (control, options, valueField, textField, selectedValue) {
        valueField = !valueField ? 'ID' : valueField;
        textField = !textField ? 'Name' : textField;
        control.find('option:not([data-persistant=true])').remove();
        for (var i = 0; i < options.length; i++) {
            control.append('<option value="' + options[i][valueField] + '">' + options[i][textField] + '</option>');
        }
        if (typeof selectedValue !== 'undefined') {
            control.val(selectedValue);
        }
    };

    me.highlightRow = function (elem, rowSelector, highlightClass) {
        rowSelector = rowSelector ? rowSelector : 'tr';
        highlightClass = highlightClass ? highlightClass : 'highlight-child-withborder';
        elem.closest(rowSelector).addClass(highlightClass).siblings().removeClass(highlightClass);
    };

    me.showChartModal = function (url, drillupUrl) {
        me.AJAX.setAJAX({ url }).then(data => {
            const params = $.deparam(url.split('?')[1]);
            $("#CHART_MODAL .title").text(params.Title ? ": " + params.Title : "")
            $("#CHART_MODAL .chart").highcharts(data);
            $("#CHART_MODAL #BACK_BUTTON").toggleClass('hidden', !((drillupUrl?.length ?? 0) > 0));
            if ((drillupUrl?.length ?? 0) > 0) {
                $("#CHART_MODAL #BACK_BUTTON").data("url", drillupUrl).attr('data-url', drillupUrl);
                $("#CHART_MODAL #BACK_BUTTON")[0].onclick = function () {
                    FD.showChartModal(drillupUrl);
                };
            }
            $("#CHART_MODAL").modal('show');
        })
    }


    //  init
    me.init = function () {
        init();
        label = me.getLabel();
    };


    /* ========================================================================
     *  override in doc ready
     * ========================================================================
    */
    me.setPageLabels = function () { };


    /* ========================================================================
     *  return
     * ========================================================================
    */
    return me;
}(jQuery, FD));

